import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { ProcessEnregistrementPayload } from 'src/app/models/process/process-parametrage';
import { ProcessService } from 'src/app/services/process/process-service';

export const processEditorResolver: ResolveFn<ProcessEnregistrementPayload> = (
  route
): Observable<ProcessEnregistrementPayload> => {
  const raw = route.paramMap.get('processId');
  const id = Number(raw);
  if (raw === null || raw === '' || Number.isNaN(id)) {
    throw new Error('Identifiant de process invalide');
  }
  return inject(ProcessService).getProcess(id) as Observable<ProcessEnregistrementPayload>;
};
